import { ManagedLeadsUpdateRequestResult } from '../../services/api/managed-leads/managedLeads';
import {
  classifyTassoQuintoError,
  getTassoQuintoErrorCode,
} from '../../services/api/tasso-quinto';
import {
  MANAGED_LEAD_DEAL_NOT_FOUND_MESSAGE,
  MANAGED_LEAD_SESSION_EXPIRED_MESSAGE,
} from './managedLeadFailures';

/** Same wording as the Mutui «Notifica» button. */
export const MANAGED_LEAD_UPDATE_REQUEST_SENT_MESSAGE =
  'Notifica inviata con successo.';

export const MANAGED_LEAD_UPDATE_REQUEST_FAILED_MESSAGE =
  'Non è stato possibile inviare la notifica.';

/**
 * The aggregate email lists at most the first 100 leads of the selection: the
 * toast says so whenever the selection was larger, so the operator never reads
 * a truncated email as the whole list.
 */
export const describeManagedLeadsUpdateRequestSuccess = ({
  listed,
  found,
}: ManagedLeadsUpdateRequestResult): string => {
  if (found === null) {
    return `Notifica inviata: l'email elenca le prime ${listed} lead.`;
  }
  if (listed < found) {
    return `Notifica inviata per ${listed} lead di ${found}: l'email elenca le prime ${listed}.`;
  }
  return `Notifica inviata con successo per ${listed} lead.`;
};

const MESSAGES_BY_CODE: Record<string, string> = {
  owner_email_unavailable:
    'Notifica non inviata: il consulente non ha un indirizzo email valido.',
  no_deals_to_notify: 'Nessuna lead da notificare con i filtri attuali.',
  deal_not_in_progress: 'Notifica non inviata: la lead non è più in gestione.',
  // The scheduler may have accepted it: retrying blindly could send it twice.
  email_outcome_uncertain:
    'Invio non confermato: la notifica potrebbe essere partita. Verifica prima di riprovare.',
};

/** Reacts to the stable envelope `code`, never to its message. */
export const describeManagedLeadUpdateRequestFailure = (
  error: unknown
): string => {
  const code = getTassoQuintoErrorCode(error);
  if (code && MESSAGES_BY_CODE[code]) return MESSAGES_BY_CODE[code];

  switch (classifyTassoQuintoError(error)) {
    case 'session_expired':
      return MANAGED_LEAD_SESSION_EXPIRED_MESSAGE;
    case 'unauthorized':
      return 'Non sei autorizzato a inviare questa notifica.';
    case 'not_found':
      return MANAGED_LEAD_DEAL_NOT_FOUND_MESSAGE;
    default:
      return MANAGED_LEAD_UPDATE_REQUEST_FAILED_MESSAGE;
  }
};
